const miniCart = document.getElementById('mini-cart');
document.addEventListener('cart:updated', () => {
  setTimeout(displayText, 1000);
});
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(displayText, 1800);
});
window.addEventListener('load', function () {
  document.getElementById('mini-cart').addEventListener('click', e => {
    const {
      target
    } = e;
    if (target.matches('.checkoutMethod')) {
      setTimeout(displayText, 10);
    }
  });
});
function displayText() {
  if (document.querySelector('.checkoutMethodsContainer>.checkoutMethod') != null) {
    if (document.querySelector('.checkoutMethodsContainer>.checkoutMethod').classList.contains('active')) {
      document.querySelector('.home-delivery-text').style.display = 'block';
      document.querySelector('.pick-up-shop-text').style.display = 'none';
    } else {
      document.querySelector('.home-delivery-text').style.display = 'none';
      document.querySelector('.pick-up-shop-text').style.display = 'block';
    }
  }
}